import styled from 'styled-components';

export const UploadMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  margin: ${({ theme }) => theme.spacings.abs24}px
    ${({ theme }) => theme.spacings.abs8}px
    ${({ theme }) => theme.spacings.abs16}px
    ${({ theme }) => theme.spacings.abs8}px;
`;
